import { doVxqlRequest } from './common.js';
import { VXGameInfo, VXGameUseAttempt } from '../VXGame.Queries.js';

const loadConfig = (configId, callback) => {
	const variables = {
		configId,
	};

	doVxqlRequest(VXGameInfo, variables).then(callback);
};

const useAttempt = (configId, callback) => {
	const variables = {
		configId,
	};

	doVxqlRequest(VXGameUseAttempt, variables).then((response) => {
		if (response.data) {
			const data = response.data.guest.vxGame.useAttempt.result;
			callback(data);
		} else {
			callback(null);
		}
	});
};

export default {
	loadConfig,
	useAttempt,
};
